import React from 'react';
import { Container, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Links from './links';
import Copy from './copyright';
import SocialIcon from './social';
import './footer.scss';

const useStyles = makeStyles(theme => ({
  footerBackgroundStyle: {
    backgroundColor: '#0D0A15',
    padding: theme.spacing(5, 0, 4.75),
  },
  divider: {
    marginTop: theme.spacing(5),
    border: 0,
    borderBottom: '1px solid #FFFFFF',
  },
}));
function footer() {
  const classes = useStyles();
  const user = useSelector(state => state.authentication);
  const footerTopMargin = useSelector((state) => state?.authentication?.footerTopMargin);
  const showHelp = (topic) => {
    window.open(topic, 'helpWindow', 'width=900,height=665,scrollbars=yes,resizable=yes');
  };
  return (
    <footer className={`${classes.footerBackgroundStyle} ${footerTopMargin ? 'footerMargin-top' : ''}`}>
      <Container className="footer-links" maxWidth={user && user.loggedIn ? 'lg' : 'md'}>
        <Links showHelp={showHelp} />
      </Container>
      {/* <Container maxWidth={user && user.loggedIn ? 'lg' : 'md'}>
        <Typography component="div" className="footer-copy-right">
          <Grid container spacing={2}>
            <Grid item xs={12}><hr className={classes.divider} /></Grid>
            <Copy showHelp={showHelp} />
            <SocialIcon />
          </Grid>
        </Typography>
      </Container> */}
    </footer>
  );
}

export default footer;

